import { RouteConfig } from "vue-router";
import Referrals from "./views/referrals/Referrals";
import Leaderboard from "./views/leaderboard/Leaderboard";

export default [
  {
    path: "/dashboard/referrals",
    component: Referrals,
    meta: { title: "Referrals" },
  },
  {
    path: "/dashboard/leaderboard",
    component: Leaderboard,
    meta: { title: "Leaderboard" },
  },
] as RouteConfig[];
